<template>
  <div id="app">
    <div class="header_container">
      <div align="center">
        <div class="logo">
          <img width="235px" height="65px" src="@/assets/header_logo.jpg"/>
          <img width="15px" height="103px" src="@/assets/home_03.jpg"/>
          <img width="323px" height="59px" src="@/assets/home_12.jpg"/>
        </div>
      </div>
      <div align="center">
        <div class="nav">
          <div class="items">
            <div class="item">
              <div class="bg01">
                <a href="http://www.lixue.org.cn/">首页</a>
              </div>
            </div>
            <div class="item">
              <div class="bg02">
                <router-link to="/course_list">在线课程</router-link>
              </div>
            </div>
            <div class="item">
              <div class="bg03">
                <router-link to="/exam_list">在线试题</router-link>
              </div>
            </div>
            <div class="item">
              <div class="bg04">
                <router-link to="/my_course">我的课程</router-link>
              </div>
            </div>
            <div class="item">
              <div class="bg05">
                <router-link to="/my_exam">我的试题</router-link>
              </div>
            </div>
            <div class="item">
              <div class="bg06">
                <router-link to="/member_info">会员中心</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <el-divider></el-divider>
    <div class="copy_right"> Copyright © 2019-2020 砺学培训 版权所有 电话：0757-88721941 粤ICP备15046821号-1</div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        header_logo_image: '@/assets/header_logo.jpg'
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0 0 0 0;
    padding: 0 0 0 0;
  }

  .header_container {
    position: relative;
    width: 100%;
    margin: 0 0 0 0;
    padding: 0 0 0 0;
    text-align: left;
    border-top: 12px solid #f24f46;
  }

  .header_container .logo {
    position: relative;
    min-width: 1040px;
    max-width: 1300px;
    height: 110px;
    margin: 0 220px 0 220px;
    overflow: hidden;
    text-align: left;
  }

  .header_container .nav {
    width: 100%;
    height: 44px;
    margin-top: 20px;
    background-color: #40bd95;
  }

  .header_container .nav .items {
    min-width: 1040px;
    max-width: 1300px;
    margin: 0 200px 0 200px;
  }

  .header_container .nav .items .item {
    float: left;
    width: 122px;
    height: 44px;
    font-family: "微软雅黑";
    font-size: 1.0em;
    color: #FFF;
    font-weight: bold;
    position: relative /*IE6 only*/;
    text-align: center;
  }

  .header_container .nav .items .item:first-child {
    margin-left: 10px;
  }

  .header_container .nav a {
    color: #FFF;
    text-decoration: none;
    line-height: 44px;
    display: block;
    width: 122px;
  }

  .header_container .nav .item .bg01 {
    background-color: #f68121;
  }

  .header_container .nav .item .bg02 {
    background-color: #55c5d1;
  }

  .header_container .nav .item .bg03 {
    background-color: #0094da;
  }

  .header_container .nav .item .bg04 {
    background-color: #f9bf1f;
  }

  .header_container .nav .item .bg05 {
    background-color: #ed008c;
  }

  .header_container .nav .item .bg06 {
    background-color: #a64686;
  }


  .copy_right {
    height: 50px;
    line-height: 50px;
    margin-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue